import { __decorate } from "tslib";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Mutation, Getter } from 'vuex-class';
import FetchInboxRecipients from '@/plugins/graphql/queries/v3/fetch-inbox-recipients.gql';
import InboxRecipients from '@/plugins/graphql/subscriptions/v3/inbox-recipients.gql';
import InboxWidget from '@/components/v3/inbox_manager/InboxWidget.vue';
import Inbox from '@/components/v3/inbox_manager/Inbox.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import WindowSizeListener from '@/helpers/vue_mixins/v3/WindowSizeListenerMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import { NAV_DRAWER } from '@/helpers/constants/app';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import Messages from '@/components/v3/inbox_manager/Messages.vue';
import ActionButton from '@/components/action_button/Index.vue';
import { normalizeKey } from '@/helpers';
import { SHOPIFY, INSURANCE } from '@/helpers/constants/Bundles';
let InboxManager = class InboxManager extends Mixins(PaginatorMixin, WindowSizeListener, ViewportSizeMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.nodes = [];
        this.messengerTotalCount = 0;
        this.facebookTotalCount = 0;
        this.activeDailyRecurringSubscribers = 0;
        this.negativeSentimentCount = 0;
        this.searchKeyword = '';
        this.isFetchMore = false;
        this.isloadingRecipient = true;
        this.showInboxList = true;
        this.showMessage = true;
        this.showWidget = true;
        this.isMessengerNotification = false;
    }
    calculateItemsPerPage() {
        if (this.window.height >= 1400) {
            return 25;
        }
        return 15;
    }
    onScreenHeightChange() {
        this.fetchRecipients();
    }
    // For Tablet and Mobile View
    onResize() {
        if (this.window.width < 1025) {
            this.openInboxList();
        }
        else {
            this.showMessage = true;
            this.showWidget = true;
        }
    }
    get bundle() {
        return normalizeKey(this.bundleKey || '');
    }
    goToCustomerSegment() {
        const shopifyKey = normalizeKey(SHOPIFY).toLowerCase();
        const insurance = normalizeKey(INSURANCE).toLowerCase();
        const key = this.bundle.toLowerCase();
        if (key === shopifyKey) {
            return this.$router.push({
                name: 'shopify-customers',
                params: { appUUID: this.appUUID, to: 'shopify-customers' },
            });
        }
        if (key === insurance) {
            return this.$router.push({
                name: 'insurance-customers',
                params: { appUUID: this.appUUID, to: 'insurance-customers' },
            });
        }
        this.$router.push({
            name: 'ecommerce-customers',
            params: {
                appUUID: this.appUUID,
                to: 'ecommerce-customers',
            },
        });
    }
    goToMessengerNotification() {
        this.isMessengerNotification = true;
        this.$router.push({
            name: 'messenger-notification',
            params: { uuid: this.appUUID, to: 'messenger-notification' },
        });
    }
    goToInviteSubscriber() {
        this.isMessengerNotification = false;
        this.$router.push({
            name: 'invite-subscriber',
            params: { uuid: this.appUUID, to: 'invite-subscriber' },
        });
    }
    goBackToOverview() {
        this.isMessengerNotification = false;
        this.showInbox(false);
        this.$router.push({
            name: 'ecommerce-overview',
            params: { uuid: this.appUUID, to: 'ecommerce-overview' },
        });
    }
    goBack() {
        if (this.showMessage) {
            this.openInboxList();
        }
        if (this.showWidget) {
            this.openInboxList();
        }
    }
    // For Tablet and Mobile View
    openMessage() {
        if (this.window.width < 1025) {
            this.showInboxList = false;
            this.showMessage = true;
            this.showWidget = false;
        }
    }
    // For Tablet and Mobile View
    openInboxList() {
        if (this.window.width < 1025) {
            this.showInboxList = true;
            this.showMessage = false;
            this.showWidget = false;
        }
    }
    // For Tablet and Mobile View
    openAccountDetails() {
        if (this.window.width < 1025) {
            this.showInboxList = false;
            this.showMessage = false;
            this.showWidget = true;
        }
    }
    get filters() {
        const baseFilters = [
            { type: 'all', label: 'All Message', count: this.totalCount },
            { type: 'messenger', label: 'Messenger', count: this.messengerTotalCount },
            {
                type: 'facebook_comment',
                label: 'Facebook Comments',
                count: this.facebookTotalCount,
            },
            {
                type: 'active_messenger_subscriptions',
                label: 'Active Daily Recurring Subscribers',
                count: this.activeDailyRecurringSubscribers,
            },
        ];
        if (this.$store.state.sentimentAnalysisEnabled) {
            baseFilters.push({
                type: 'negative_sentiment',
                label: 'Negative Sentiment',
                count: this.negativeSentimentCount || 0,
            });
        }
        return baseFilters;
    }
    mapNewRecipients(recipients) {
        let isExisting = false;
        const upadateRecipients = this.nodes.filter((recipient) => {
            if (recipient.baseUuid === recipients.baseUuid) {
                isExisting = true;
                return false;
            }
            return true;
        });
        if (!isExisting && this.searchKeyword === '') {
            this.updateTotalCountsByFilter(recipients);
        }
        this.nodes = [recipients, ...upadateRecipients];
        this.$store.commit('setRecipients', this.nodes);
    }
    updateTotalCountsByFilter(recipients) {
        if (recipients.inboxPlatformOrigin.includes('facebook_comment')) {
            this.facebookTotalCount += 1;
        }
        else if (recipients.inboxPlatformOrigin.includes('messenger')) {
            this.messengerTotalCount += 1;
        }
        this.totalCount += 1;
    }
    toggleFilter(type) {
        this.$store.commit('setSelectedFilter', type);
        this.isloadingRecipient = true;
        this.fetchRecipients();
    }
    fetchRecipients() {
        this.isloadingRecipient = true;
        this.$apollo
            .query({
            query: FetchInboxRecipients,
            variables: {
                appUuid: this.$store.state.appUUID,
                first: this.calculateItemsPerPage(),
                after: this.startCursor,
                keyword: this.searchKeyword || '',
                selectedFilter: this.selectedFilter,
            },
        })
            .then(({ data }) => {
            if (data) {
                this.nodes = data.fetchInboxRecipients.edges.map((edge) => edge.node);
                this.$store.commit('setRecipients', this.nodes);
                this.pageInfo = data.fetchInboxRecipients.pageInfo;
                const { totalCount, messengerRecipientTotal, facebookRecipientTotal, activeSubscriberTotal, } = data.fetchInboxRecipients;
                if (this.selectedFilter === 'all' && this.searchKeyword !== '') {
                    this.messengerTotalCount = messengerRecipientTotal;
                    this.facebookTotalCount = facebookRecipientTotal;
                    this.activeDailyRecurringSubscribers = activeSubscriberTotal;
                }
                this.isloadingRecipient = false;
            }
        })
            .catch((error) => {
            console.log(error);
            this.isloadingRecipient = false;
        });
    }
    fetchMoreRecipients() {
        if (this.isFetchMore) {
            return; // Do not fetch more if already in progress
        }
        const { endCursor, hasNextPage } = this.pageInfo;
        if (hasNextPage) {
            this.isFetchMore = true; // Set flag to indicate fetch in progress
            this.$apollo
                .query({
                query: FetchInboxRecipients,
                variables: {
                    appUuid: this.$store.state.appUUID,
                    first: 10,
                    after: endCursor,
                    keyword: this.searchKeyword || '',
                    selectedFilter: this.selectedFilter,
                },
            })
                .then(({ data }) => {
                if (data) {
                    this.pageInfo = data.fetchInboxRecipients.pageInfo;
                    const moreNodes = data.fetchInboxRecipients.edges.map((edge) => edge.node);
                    this.nodes = [...this.nodes, ...moreNodes];
                    this.$store.commit('setRecipients', this.nodes);
                    this.isFetchMore = false;
                }
            })
                .catch((error) => {
                console.log(error);
                this.isFetchMore = false;
            });
        }
        else {
            this.isFetchMore = false;
        }
    }
    updateCountsByFilter(totalCount, messengerRecipientTotal, facebookRecipientTotal, activeSubscriberTotal, negativeSentimentCount) {
        if (this.selectedFilter === 'all' || !this.totalCount) {
            this.totalCount = totalCount;
        }
        if (this.selectedFilter === 'messenger' || !this.messengerTotalCount) {
            this.messengerTotalCount = messengerRecipientTotal;
        }
        if (this.selectedFilter === 'facebook_comment' || !this.facebookTotalCount) {
            this.facebookTotalCount = facebookRecipientTotal;
        }
        if (this.selectedFilter === 'active_messenger_subscriptions' ||
            !this.activeDailyRecurringSubscribers) {
            this.activeDailyRecurringSubscribers = activeSubscriberTotal;
        }
        if (this.selectedFilter === 'negative_sentiment' || !this.negativeSentimentCount) {
            this.negativeSentimentCount = negativeSentimentCount;
        }
    }
    handleLoadMore() {
        this.fetchMoreRecipients();
    }
    handleSearch(keyword) {
        this.searchKeyword = keyword;
        this.fetchRecipients();
    }
    mounted() {
        this.showInbox(true);
        this.isloadingRecipient = true;
    }
    destroyed() {
        this.showInbox(false);
    }
};
__decorate([
    Getter('selectedRecipient')
], InboxManager.prototype, "selectedRecipient", void 0);
__decorate([
    Mutation('showInbox', { namespace: NAV_DRAWER })
], InboxManager.prototype, "showInbox", void 0);
__decorate([
    Getter('selectedFilter')
], InboxManager.prototype, "selectedFilter", void 0);
__decorate([
    Watch('window.height')
], InboxManager.prototype, "onScreenHeightChange", null);
__decorate([
    Watch('window.width')
], InboxManager.prototype, "onResize", null);
InboxManager = __decorate([
    Component({
        apollo: {
            recipients: {
                query: FetchInboxRecipients,
                variables() {
                    return {
                        appUuid: this.$store.state.appUUID,
                        first: this.calculateItemsPerPage(),
                        after: this.startCursor,
                        keyword: this.searchKeyword || '',
                        selectedFilter: this.selectedFilter,
                    };
                },
                update({ fetchInboxRecipients }) {
                    this.nodes = fetchInboxRecipients.edges.map((edge) => edge.node);
                    this.$store.commit('setRecipients', this.nodes);
                    this.pageInfo = fetchInboxRecipients.pageInfo;
                    const { totalCount, messengerRecipientTotal, facebookRecipientTotal, activeSubscriberTotal, negativeSentimentCount, } = fetchInboxRecipients;
                    if (this.nodes.length > 0) {
                        const { uuid, inboxPlatformOrigin, baseUuid, photo } = this.nodes[0];
                        const selectedItem = { uuid, inboxPlatformOrigin, baseUuid, photo };
                        this.$store.commit('setSelectedRecipient', selectedItem);
                    }
                    this.updateCountsByFilter(totalCount, messengerRecipientTotal, facebookRecipientTotal, activeSubscriberTotal, negativeSentimentCount);
                    this.isloadingRecipient = false;
                },
                subscribeToMore: {
                    document: InboxRecipients,
                    variables() {
                        return {
                            appGlobalId: this.$store.state.appGlobalId,
                            selectedFilter: this.selectedFilter,
                        };
                    },
                    updateQuery(previousResult, { subscriptionData }) {
                        const { recipients } = subscriptionData.data.inboxRecipients;
                        if (this.searchKeyword === '') {
                            this.mapNewRecipients(recipients);
                        }
                        return subscriptionData.data.inboxRecipients.recipients;
                    },
                },
                fetchPolicy: 'network-only',
            },
        },
        components: {
            PageTitle,
            Inbox,
            InboxWidget,
            BaseOverlayLoader,
            Messages,
            ActionButton,
        },
    })
], InboxManager);
export default InboxManager;
